import { jsx as _jsx } from "react/jsx-runtime";
import { getExtStyles } from "@air/component-file-extension-preview";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
import FileExtensionPreview from "~/components/FileExtensionPreview";
export const AssetGalleryCardFailedTranscode = /*#__PURE__*/ memo((param)=>{
    let { className, ext } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("flex flex-1 flex-col items-center justify-center", className),
        style: {
            /**
         * Todo: get rid of theme. to do that though,
         * getExtStyles (and all underlying functions) will need to be refactored
         */ backgroundColor: getExtStyles(ext).bgColor
        },
        children: /*#__PURE__*/ _jsx(FileExtensionPreview, {
            ext: ext,
            text: "No preview available",
            color: "color",
            size: "medium",
            className: "grow justify-center"
        })
    });
});
AssetGalleryCardFailedTranscode.displayName = "AssetGalleryCardFailedTranscode";
